(function () {
  const sectionInstances = new WeakMap();

  class MulticolumnSection {
    constructor(section) {
      this.section = section;
      this.container = section.querySelector(".swiper");
      this.layoutEl = this.container?.querySelector(".swiper-wrapper");
      this.wrapper = this.layoutEl;

      if (!this.container || !this.layoutEl || !this.wrapper) return;

      this.layout = this.container.dataset.layout || "grid";
      this.allSlides = Array.from(this.wrapper.children);
      this.perRow = Number(this.layoutEl.dataset.cardsPerRow || 1);
      this.breakpointMap = this.buildBreakpointMap();
      this.swiper = null;
      this.resizeObserver = null;

      if (this.layout === "slider") {
        this.initSwiper();
        this.bindResize();
      }
    }

    buildBreakpointMap() {
      const steps = [
        { bp: 0, cols: 1 },
        { bp: 750, cols: 2 },
        { bp: 1200, cols: 3 },
        { bp: 1536, cols: 4 },
      ];
      return steps.filter((step) => step.cols <= this.perRow);
    }

    getCurrentCols() {
      const viewportWidth = window.innerWidth;
      let cols = 1;
      this.breakpointMap.forEach((step) => {
        if (viewportWidth >= step.bp) {
          cols = step.cols;
        }
      });
      return cols;
    }

    updateOverflow() {
      if (this.layout !== "slider") return;
      const visibleSlides =
        this.wrapper.querySelectorAll(".multicolumn-card").length;
      const currentCols = this.getCurrentCols();
      this.layoutEl.classList.toggle(
        "has-overflow",
        visibleSlides > currentCols
      );
    }

    initSwiper() {
      if (this.layout !== "slider" || !this.wrapper.children.length) {
        this.layoutEl.classList.remove("has-overflow");
        return;
      }

      // Mobile centers the intermediate slides, first/last stay flush to the edges.
      // Must be switched off explicitly at 750 — breakpoint params merge, they don't reset.
      this.swiper = new Swiper(this.container, {
        slidesPerView: "auto",
        touchEventsTarget: "container",
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        speed: 1000,
        centeredSlides: true,
        centeredSlidesBounds: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          750: {
            spaceBetween: 24,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
        on: {
          init: () => {
            this.layoutEl.classList.remove("multicolumn__wrapper--pre-init");
            this.updateOverflow();
          },
          resize: () => {
            this.updateOverflow();
          },
        },
      });
    }

    bindResize() {
      if (typeof ResizeObserver === "undefined") return;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.swiper) this.swiper.update();
      });
      this.resizeObserver.observe(this.layoutEl);
    }

    destroy() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
      }
      this.swiper = null;
    }
  }

  const initMulticolumnSection = (section) => {
    if (!section || !section.classList.contains("multicolumn-section")) return;
    const existingInstance = sectionInstances.get(section);
    if (existingInstance) existingInstance.destroy();
    sectionInstances.set(section, new MulticolumnSection(section));
  };

  initMulticolumnSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initMulticolumnSection(event.target);
  });
})();
